module.exports = __webpack_public_path__ + "img/cq-banner.cee34844.png";